function AdvertiserDashboard() {
	return <div></div>;
}

export default AdvertiserDashboard;
